import { render, staticRenderFns } from "./Cv.vue?vue&type=template&id=639b3790&scoped=true&"
import script from "./Cv.vue?vue&type=script&lang=js&"
export * from "./Cv.vue?vue&type=script&lang=js&"
import style0 from "./Cv.vue?vue&type=style&index=0&id=639b3790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b3790",
  null
  
)

export default component.exports